export enum StockTrackingChartInterval {
    OneHour,
    OneDay,
    OneWeek,
    OneMonth,
    TwoMonths,
    OneYear,
    FiveYears,
    OneMinute,
    FifteenMinutes,
}
